import { Plus, Trash2 } from "lucide-react";
import { fmtMoney } from "@/lib/api";

export function LineItemsEditor({ items, onChange, settings }) {
  const update = (i, k, v) => onChange(items.map((it, idx) => (idx === i ? { ...it, [k]: v } : it)));
  const remove = (i) => onChange(items.filter((_, idx) => idx !== i));
  const add = () => onChange([...items, { description: "", quantity: 1, unit_price: 0 }]);

  return (
    <div className="space-y-3" data-testid="line-items">
      <div className="hidden sm:grid grid-cols-12 gap-2 overline">
        <div className="col-span-6">Description</div>
        <div className="col-span-2 text-right">Qty</div>
        <div className="col-span-3 text-right">Unit price</div>
      </div>
      {items.map((it, i) => (
        <div key={i} className="grid grid-cols-12 gap-2 items-center" data-testid={`line-item-${i}`}>
          <input className="field col-span-12 sm:col-span-6" placeholder="Service or product" value={it.description} data-testid={`item-description-${i}`} onChange={(e) => update(i, "description", e.target.value)} />
          <input className="field col-span-4 sm:col-span-2 text-right font-mono" type="number" min="0" step="any" value={it.quantity} data-testid={`item-quantity-${i}`} onChange={(e) => update(i, "quantity", e.target.value === "" ? "" : Number(e.target.value))} />
          <input className="field col-span-6 sm:col-span-3 text-right font-mono" type="number" min="0" step="0.01" value={it.unit_price} data-testid={`item-price-${i}`} onChange={(e) => update(i, "unit_price", e.target.value === "" ? "" : Number(e.target.value))} />
          <button type="button" onClick={() => remove(i)} data-testid={`item-remove-${i}`} className="col-span-2 sm:col-span-1 h-11 grid place-items-center border border-border hover:border-destructive hover:text-destructive transition-colors">
            <Trash2 className="w-4 h-4" strokeWidth={1.5} />
          </button>
          <div className="col-span-12 sm:hidden text-right font-mono text-xs text-muted-foreground">{fmtMoney(Number(it.quantity || 0) * Number(it.unit_price || 0), settings)}</div>
        </div>
      ))}
      <button type="button" onClick={add} data-testid="add-line-item" className="btn-press h-10 px-4 text-sm font-semibold border border-foreground hover:bg-foreground hover:text-background flex items-center gap-2">
        <Plus className="w-4 h-4" strokeWidth={2} /> Add line item
      </button>
    </div>
  );
}
